import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Calculator from './pages/Calculator';
import Products from './pages/Products';
import Parameters from './pages/Parameters';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './i18n'; // i18n yapılandırmasını içe aktar
import i18n from './i18n';
import { useAuth } from './context/AuthContext';

/**
 * Korumalı Route bileşeni - Oturum yoksa giriş sayfasına yönlendirir
 * @param {Object} props - Bileşen özellikleri
 * @returns {JSX.Element} Korumalı route bileşeni
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { checkAuth, loading } = useAuth();
  const isAuthenticated = checkAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-slate-50 to-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-600 border-solid mx-auto mb-4"></div>
          <p className="text-slate-700">Yükleniyor...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    // Giriş sayfasına yönlendir, mevcut URL'yi state olarak kaydet
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  
  return children;
};

/**
 * App bileşeni - Uygulamanın ana bileşeni
 * @returns {JSX.Element} Ana uygulama bileşeni
 */
const App = () => {
  // Dil tercihi için localStorage kontrolü
  useEffect(() => {
    // LocalStorage'dan dil tercihini al ve uygula
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);
  
  return (
    <Router>
      <Toaster 
        position="bottom-center" 
        toastOptions={{
          duration: 3000,
          style: {
            border: '1px solid #f0f0f0',
            padding: '12px',
            color: '#333',
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route 
          path="/calculator" 
          element={
            <ProtectedRoute>
              <Calculator />
            </ProtectedRoute>
          } 
        />
        <Route path="/products" element={<Products />} />
        <Route path="/parameters" element={<Parameters />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
